import React from 'react';
import PropTypes from 'prop-types';
import StatisticButton from 'components/Managers/Dashboard/Views/Statistics/StatisticButton';

export default function Members({ value }) {
  return (
    <StatisticButton
      label="Members"
      value={value}
        // onClick={() => setShowModal(true)}
      className="bg-secondary-100"
    />
  );
}

Members.propTypes = {
  value: PropTypes.number,
};

Members.defaultProps = {
  value: null,
};
